import React from 'react';

/**
 * Products page hero — the same full-bleed `.hero` the home page opens with,
 * so the two pages read as one site: photo as background, navy gradient on
 * the left, the words in the text well. Replaces the boxed RoundBanner
 * (the July ingredients-banner card), which Jarvis flagged 2026-09-04 as
 * not matching the site — nav against a blank band, a 1200px box where the
 * hero runs edge to edge.
 *
 * Background is the board shot: one food, three forms on one counter.
 * `hero--products` keeps the subject in frame (centered, shorter than the
 * home hero's full viewport). background-image is inline for the same
 * reason as Hero.tsx — CRA's css-loader can't resolve /images/... from src/.
 */
export function ProductsHero() {
  const bg = `url(${process.env.PUBLIC_URL}/images/product/truenooch-three-forms-hero.webp)`;
  return (
    <div
      className="hero hero--products"
      style={{ backgroundImage: bg }}
      role="img"
      aria-label="A sunlit kitchen counter with the three forms of TrueNooch™: a Round wrapped in white paper with a navy band, a kraft pouch of TrueNooch™ Flour, a jar of cubes, a loaf baked with the flour cooling in its tin, and an open-faced sandwich of sliced rounds, tomato and lettuce."
    >
      <div className="hero-content">
        <div className="hero-badge">Made in Colorado</div>
        <h1 className="hero-title">One food, three forms.</h1>
        <p className="hero-sub">
          Slice off a round.<br />
          Real ingredients.<br />
          Complete protein.
        </p>
      </div>
    </div>
  );
}
